(function () {
  'use strict';

  /* @ngdoc object
   * @name smsManager
   * @description
   *
   */
  angular
    .module('smsManager', [
      'ui.router'
    ]);
}());
